import React, { useState, useEffect } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import { useNavigate } from "react-router-dom";
import Table from "../../components/Table";
import Checkbox from "../../components/Checkbox";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { ToolCase, Trash2, Printer, Upload } from "lucide-react";
import QRCodeGenerator from '../../components/QRCodeGenerator.jsx';
import * as XLSX from 'xlsx';
import Loader from '../../components/Loader.jsx';

const RowPC = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-center">
                <Checkbox
                    checked={data.checked}
                    onChange={() => onCheckboxChange(data.value.CodiceUnivoco)}
                    size={18}
                />
            </div>
            <div className="grid grid-cols-2 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.CodiceUnivoco}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataCreazione}
                </div>
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
}

const Codici = () => {
    const headers = [
        { label: "Codice", key: "CodiceUnivoco" },
        { label: "Data Creazione", key: "DataCreazione" }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isActionsVisible, setIsActionsVisible] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [quantita, setQuantita] = useState(0);
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        try {

            await loadNav();

            const r1 = await fetch("/getQRCodeByUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ID: infoUtente.ID })
            });

            const rd1 = await r1.json();

            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { navigate("/manager/dash") }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTable(rd1.map((d) => ({ value: d, checked: false })));
            };

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei codici, riprovare più tardi", onClose: () => { navigate("/manager/dash") }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleStampa = async () => {
        const selectedElements = dataTable.filter((d) => d.checked).map((d) => d.value["CodiceUnivoco"]);
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
        const qrCodes = await generaQrCode(selectedElements);

        //open window to print all qrCodes
        const printWindow = window.open("", "", "width=600,height=600");
        printWindow.document.write("<html><head><title>QRCode</title></head><body>");
        qrCodes.forEach((d) => {
            printWindow.document.write(`<img src="${d}" alt="QRCode non disponibile" />`);
        });
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        await new Promise((resolve) => setTimeout(resolve, 500));
        printWindow.print();
    };

    const handleElimina = async () => {
        const selectedElements = dataTable.filter((d) => d.checked).map((d) => d.value["CodiceUnivoco"]);
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        const pass = async () => {
            setIsLoading(true);

            try {
                const r = await fetch("/eliminaQrCodes", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ QRCode: selectedElements })
                });

                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nell'eliminazione dei codici, riprovare più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }

            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare i codici selezionati?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const handleExport = () => {
        const selectedElements = dataTable.filter((d) => d.checked).map(d => ({ Codice: d.value["CodiceUnivoco"], DataCreazione: d.value["DataCreazione"] }));
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(selectedElements);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const generaQrCode = async (ids) => {
        let qrCodes = [];
        for (let i = 0; i < ids.length; i++) {
            qrCodes.push(await QRCodeGenerator.generateQRCode(ids[i]));
        }
        return qrCodes;
    };

    const handleConferma = async () => {
        if (quantita <= 0) {
            setAlertInfo({ type: "warning", text: "Inserire una quantità valida", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        let codici = [];

        for (let i = 0; i < quantita; i++) {
            let codice = await generateUniqueID();
            codici.push(codice);
        }

        try {
            const response = await fetch("/addQrCodes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ QRCode: codici, ID: infoUtente.ID })
            });

            if (response.status === 500) {
                const rd = await response.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                // if (!isLittle) {
                //     const qrCodes = await generaQrCode(codici);

                //     //open window to print all qrCodes
                //     const printWindow = window.open("", "", "width=600,height=600");
                //     printWindow.document.write("<html><head><title>QRCode</title></head><body>");
                //     qrCodes.forEach((d) => {
                //         printWindow.document.write(`<img src="${d}" alt="QRCode non disponibile" />`);
                //     });
                //     printWindow.document.write("</body></html>");
                //     printWindow.document.close();
                //     await new Promise((resolve) => setTimeout(resolve, 500));
                //     printWindow.print();
                // }

                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta dei codici, riprovare più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const generateUniqueID = async () => {
        let tempID = `${Date.now()}-${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
        return tempID;
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"CODICI QR"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={["CodiceUnivoco"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    classes="mt-2"
                    needCheckbox={true}
                    keyForCheck="CodiceUnivoco"
                    renderButtonForCheckbox={() =>
                        <Button type="hollow" onClick={() => setIsActionsVisible(true)}>
                            AZIONI <ToolCase size={16} strokeWidth={2} className="inline-block ml-1" />
                        </Button>
                    }
                    needAdd={true}
                    addAction={() => setIsAddVisible(true)}

                />
                <PopUp title={"Aggiungi codici"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={handleConferma}
                    cancelAction={() => setIsAddVisible(false)}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Quantità *"
                            value={quantita}
                            setValue={setQuantita}
                            type="number"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
                <PopUp title={"Azioni disponibili"}
                    isVisible={isActionsVisible}
                    setIsVisible={setIsActionsVisible}
                    needConfirm={false}
                >
                    <>
                        <div className="grid grid-cols-2 mt-2">
                            <Button type="hollow" onClick={handleElimina}>
                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                            <Button type="hollow" onClick={handleStampa}>
                                STAMPA <Printer size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </div>
                        <div className="flex items-center justify-center mt-2">
                            <Button type="hollow" classes="w-[50%]" onClick={handleExport}>
                                EXPORT <Upload size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </div>
                    </>
                </PopUp>
            </div>
        </div>
    )
};
export default Codici;